/**
 * Label + value pair used on Settings user detail panels.
 */
export function DetailField({ label, value, children }) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-500">{label}</div>
      <div className="mt-1 text-gray-900">{children || value || "—"}</div>
    </div>
  );
}

export default DetailField;
